module.exports = __webpack_public_path__ + "images/1708667f1581f948673592bf18b0436685d847f13e1d0f369f8b9f1bf5e0ddc5.svg";